import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { trackCreateBookingClick } from '../actions/analytics';

import Calendar from '../components/Calendar/Calendar';

class CalendarContainer extends Component {
    static propTypes = {
        bookings: PropTypes.object,
        person: PropTypes.object,
    }

    render() {
        return (
            <Calendar { ...this.props } />
        );
    }
}

function mapStateToProps(state) {
    const { bookings } = state.entities;
    const { user, person } = state.environment;

    return {
        bookings,
        user,
        person,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ trackCreateBookingClick }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarContainer);



// WEBPACK FOOTER //
// ./scripts/containers/CalendarContainer.jsx